import { render, staticRenderFns } from "./SchoolDisplayAndEdit.vue?vue&type=template&id=1fd9d3fa&scoped=true&"
import script from "./SchoolDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./SchoolDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDisplayAndEdit.vue?vue&type=style&index=0&id=1fd9d3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9d3fa",
  null
  
)

export default component.exports